var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.4 4C3.7558 4 3 4.65759 3 5.75V22.25C3 23.3424 3.7558 24 4.4 24H23.6C24.2442 24 25 23.3424 25 22.25V5.75C25 4.65759 24.2442 4 23.6 4H4.4ZM1 5.75C1 3.81741 2.4042 2 4.4 2H23.6C25.5958 2 27 3.81741 27 5.75V22.25C27 24.1826 25.5958 26 23.6 26H4.4C2.4042 26 1 24.1826 1 22.25V5.75Z",
    fill: "#0A645A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.29941 5.26182C1.6935 4.90815 2.32664 4.91346 2.71356 5.27368L14 15.7812L25.2864 5.27368C25.6734 4.91346 26.3065 4.90815 26.7006 5.26182C27.0947 5.61549 27.1005 6.19422 26.7136 6.55445L14.7136 17.7263C14.5255 17.9014 14.2684 18 14 18C13.7316 18 13.4745 17.9014 13.2864 17.7263L1.28644 6.55445C0.899511 6.19422 0.90532 5.61549 1.29941 5.26182Z",
    fill: "#0A645A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsIcon);
export default __webpack_public_path__ + "static/media/sms-icon.708f578f6ff22cb85ad2a737b998f91a.svg";
export { ForwardRef as ReactComponent };